import styled from 'styled-components'

import { ColumnFlex, FlexCentered } from 'components/common/genericStyles'
import { artefactColors } from 'constants/color'

export const Container = styled.div`
    height: 100vh;
    width: 100vw;
    background: ${props =>
        props.isQuizMode ? artefactColors.quiz : artefactColors.focusMode};
    ${ColumnFlex}
`

export const Header = styled.div`
    height: 48px;
    width: 100%;
    border-top: 1px solid #ffffff8f;
    z-index: 99;
`

export const Body = styled.div`
    width: 100%;
    height: -webkit-fill-available;
    ${FlexCentered}
    overflow: hidden auto;
`

export const Footer = styled.div`
    height: 48px;
    width: 100%;
    margin: 15px 0px;
    z-index: 99;
`
